// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"4266ebf2","139":"f161281e","659":"242bc4d8","667":"08b81e60"}[chunkId] + ".chunk.js";
};